import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { SuccessIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { ListItem } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ChecklistItem = ({
  message
}) => {
  return /*#__PURE__*/_jsx(ListItem, {
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "baseline",
      children: [/*#__PURE__*/_jsx(IconHolder, {
        icon: SuccessIcon,
        color: "icon-core-default"
      }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: message
      })]
    })
  });
};
export default ChecklistItem;